import { FileText, Loader2, Trash2 } from 'lucide-react';
import { fixFilenameMojibake } from '@ideoz/core';
import type { Attachment } from '../files.types';

const formatSize = (bytes?: number) => {
  if (!bytes || bytes <= 0) return '';
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(0)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
};

interface FileRowProps {
  attachment: Attachment;
  isDeleting: boolean;
  onDelete: (id: string) => void;
}

/** Dumb: a single attachment row with a delete affordance. */
export function FileRow({ attachment, isDeleting, onDelete }: FileRowProps): JSX.Element {
  const name = fixFilenameMojibake(
    attachment.fileName ?? attachment.name ?? attachment.originalName ?? 'Untitled'
  );
  const size = formatSize(attachment.fileSize ?? attachment.size);

  return (
    <li className="flex items-center gap-3 px-4 py-3">
      <FileText className="w-5 h-5 text-gray-400 dark:text-gray-500 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm text-gray-800 dark:text-gray-100 truncate">{name}</p>
        {size && <p className="text-xs text-gray-400 dark:text-gray-500">{size}</p>}
      </div>
      <button
        type="button"
        onClick={() => onDelete(attachment.id)}
        disabled={isDeleting}
        className="text-gray-400 dark:text-gray-500 hover:text-red-500 dark:hover:text-red-400 transition-colors disabled:opacity-50"
        aria-label={`Delete ${name}`}
      >
        {isDeleting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Trash2 className="w-4 h-4" />}
      </button>
    </li>
  );
}
